export default __webpack_public_path__ + "static/media/SemDados.c6e1b9f5.svg";